import React from 'react';
import {connect} from 'react-redux';
import Combobox from '@cybs-ui/components/lib/combobox';
import {putDataInDevCenterDataStore} from '../../../../../app/store';
import Textfield from '@cybs-ui/components/lib/textfield';
import { getCustomHeadersSelectedValue } from '../../../../../lhs/reducers/lhs-reducer';


var requestHeaders = {};
class CustomHeaders extends React.Component
{
    
    render(){
        
        var customHeaders = this.props.customHeaders;
        var requestOptions = [];
        var selectedItem = [];
        var headerName = "";
        const handleSelection = (event, selectedItem) => {
            var itemMap = getCustomHeadersSelectedValue();
            itemMap[headerName] = selectedItem[0].value
            putDataInDevCenterDataStore({type: 'UPDATE_CUSTOM_HEADERS_SELECTED_VALUE', customHeadersSelectedValue: itemMap});
        }
        if(customHeaders != null)
        {   
            customHeaders = <div id ="customRequestHeaders">
            { 
                Object.keys(this.props.customHeaders).map((key, i) => {
                    var i;
                    headerName = key;
                    
                    if(this.props.customHeaders[key].length >1)
                    {
                        for(i=0; i<this.props.customHeaders[key].length; i++){
                            requestOptions.push({value: this.props.customHeaders[key][i], label: this.props.customHeaders[key][i] });
                        }
                        
                        if(this.props.customHeadersSelectedValue == undefined)
                        {
                            this.props.customHeadersSelectedValue = {};
                            
                        }
                        if(!(key in this.props.customHeadersSelectedValue))
                        {
                            selectedItem = requestOptions[0];
                            this.props.customHeadersSelectedValue[key] = requestOptions[0].value;
                        }
                        else
                        {
                            selectedItem =  this.props.customHeadersSelectedValue[key];
                        }
                        
                        putDataInDevCenterDataStore({type: 'UPDATE_CUSTOM_HEADERS_SELECTED_VALUE', customHeadersSelectedValue: this.props.customHeadersSelectedValue});
                        var counter = this.props.customHeaderCounter;
                        counter++;
                        if(this.props.requestHeaders && (Object.keys(this.props.requestHeaders).length+i+1)%2 == 0 && this.props.customHeaders[key].length >1)
                        {
                            return (<tr key={i} class="evenRow">
                            <td class ="key">{key}</td>
                            <td class = "value">
                                    <Combobox 
                            dataTest="custom-type-drop-down"
                            i18n={{
                                label: ""
                            }}
                            items={requestOptions}
                            selectedItems={[selectedItem]}
                            onSelect={handleSelection}
                            width="auto"
                            class = "customTypeHeaders"
                            />
                            </td>
                          </tr>)
                        }
                        else
                        {
                            return(<tr key={i} class="oddRow">
                             <td class ="key">{key}</td>
                            <td class = "value">
                                    <Combobox 
                            dataTest="custom-type-drop-down"
                            i18n={{
                                label: ""
                            }}
                            items={requestOptions}
                            selectedItems={[selectedItem]}
                            onSelect={handleSelection}
                            width="auto"
                            class = "customTypeHeaders"
                            />
                            </td>
                          </tr>)
                        }
                    }
                    else
                    {
                        if(this.props.customHeadersSelectedValue == undefined)
                        {
                            this.props.customHeadersSelectedValue = {};
                            
                        }
                        if(!(key in this.props.customHeadersSelectedValue))
                        {
                            this.props.customHeadersSelectedValue[key] = '';
                        }

                        if((Object.keys(this.props.requestHeaders).length+i+1)%2 == 0) 
                        {
                            return (<tr key={i} class="evenRow">
                            <td class ="key">{key}</td>
                            <td class = "value">
                                <Textfield
                                class = "customTypeHeaders"
                                i18n={{
                                    label: ""
                                }}
                                required={true}
                                value={this.props.customHeadersSelectedValue[key]== undefined ? '' : this.props.customHeadersSelectedValue[key]}
                                onChange={e => {
                                this.props.customHeadersSelectedValue[key] = (e.target.value)
                                putDataInDevCenterDataStore({type: 'UPDATE_CUSTOM_HEADERS_SELECTED_VALUE', customHeadersSelectedValue: this.props.customHeadersSelectedValue});
                                var counter = this.props.customHeaderCounter;
                                counter++;
                                }}
                            />
                            </td>
                          </tr>)
                        }
                        else
                        {
                            return(<tr key={i} class="oddRow">
                            <td class ="key">{key}</td>
                            <td class = "value">
                                <Textfield
                                class = "customTypeHeaders"
                                i18n={{
                                    label: ""
                                }}
                                required={true}
                                value={this.props.customHeadersSelectedValue[key]== undefined ? '' : this.props.customHeadersSelectedValue[key]}                                onChange={e => {
                                this.props.customHeadersSelectedValue[key] = (e.target.value)
                                putDataInDevCenterDataStore({type: 'UPDATE_CUSTOM_HEADERS_SELECTED_VALUE', customHeadersSelectedValue: this.props.customHeadersSelectedValue});
                                var counter = this.props.customHeaderCounter;
                                counter++;
                                }}
                            />
                            </td>
                          </tr>)
                        }
                    }
                   
                })                          
            }
            </div>
        }
        else
        {
            customHeaders =  <div id ="customHeaders">
            </div>  
        }
        return(         
        
               <span>
                   {customHeaders}
                   </span>
            
        )
    };
}

function mapStateToProps(state){
    return{
        customHeaders: state.lhsReducer.customHeaders,
        customHeaderCounter: state.lhsReducer.customHeaderCounter,
        requestHeaders: state.rhsReducer.requestHeaders
  }
}

export default connect(mapStateToProps)(CustomHeaders);
export {CustomHeaders};